#import "./TripFragment.graphql"
#import "../../../../list/TravelSectionAuthDataFragment.graphql"

mutation TripUpdate($input: TripUpdateInput!) {
  tripUpdate(input: $input) {
    trip {
      id
      travelerId
      _stopsValidation
      _isDeletable
      _rowTimestamp
      travelerReferenceName
      traveler {
        id
        _fullName
        _isUpdatable
        _isAliasInvoked
        _isAliasOriginalNameViewable
        _pickupAddress
        isEconomyClassPreferred
        isBusinessClassPreferred
        isFirstClassPreferred
        vendorNumber
        _isApproved
        department {
          name
        }
        userOccupation {
          userOccupationTitle
        }
        travelerAddressesByTravelerId(orderBy: IS_PRIMARY_DESC) {
          nodes {
            id
            _rowTimestamp
            addressLine1
            addressLine2
            cityName
            countryId
            stateRegionId
            postalCode
            telephoneNumber
            emailAddress
            isGroundTransferAddress
            isDeliveryAddress
            isPrimary
            stateRegion {
              stateRegion
              country {
                country
              }
            }
          }
        }
        travelPolicy {
          id
          isCompanion
          description
          isContractual
          isDefaultCustomizable
          companyCurrency {
            isoCode
          }
        }
        _travelPolicyAllowances(
          orderBy: TRAVEL_POLICY_EXPENDITURE_TYPE_BY_EXPENDITURE_TYPE_ID__SORT_ORDER_ASC
        ) {
          nodes {
            id
            expenditureType {
              expenditureType
            }
            allowanceOverrideAmount
            _allowanceDescription
            isAllowanceCustomizable
            _travelerPolicyAllowanceRowTimestamp
            _travelerPolicyAllowanceId
          }
        }
      }
      controlTotalAmount
      airfareAmount
      accommodationAmount
      vehicleRentalAmount
      transportationAmount
      otherAmount
      specialInstructions
      comments
      _isOverBudget
      incidentalAmount
      tripLocator
      travelAuthorizationId
      travelAuthorization {
        _isPlanningPhase
        currency {
          id
          isoCode
          currencySymbol
        }
      }
      warningInfo1
      warningInfo2
      warningInfo3
      warningValue1
      warningValue2
      warningValue3
      tripItems {
        nodes {
          ...TripItemFragment
        }
      }
    }
    travelAuthorization {
      __typename
      id
      stampedEntityDocumentId
      _isOverBudget
      isDraft
      _isApprovalRevocable
      _isStagedApprovalRequest
      requiredDate
      requiredTime
      _rowTimestamp
      _isUpdatable
      _isDeletable
      budgetAmount
      controlTotalAmount
      _requiredApprovalDocuments
      isDraft
      requiredDate
      requiredTime
      _isPlanningPhase
      trips(orderBy: [TRAVELER_REFERENCE_NAME_ASC , TRIP_LOCATOR_ASC]) {
        nodes {
          id
          _rowTimestamp
          tripLocator
          travelerReferenceName
          accountReference
          airfareAmount
          accommodationAmount
          transportationAmount
          vehicleRentalAmount
          trainAmount
          otherAmount
          controlTotalAmount
          _isOverBudget
          budgetAmount
          _requiredApprovalDocuments
        }
      }
      notesByEntityId(orderBy: _CREATED_DATE_DESC) {
        nodes {
          id
          _createdByUserName
          _createdDate
          noteComment
          isShared
          _isUpdatable
          _rowTimestamp
          _isDeletable
        }
      }
      ...TravelAuthorizationTravelSectionFragment
    }
  }
}
